import { Heading, Subheading } from "../../../components/catalyst/Heading";

export function SuccessState() {
	return (
		<>
			<Heading>You're all set!</Heading>
			<Subheading>Your payout account has been configured.</Subheading>
		</>
	);
}
